import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { SHA1 } from 'crypto-js';
import { EChartsOption } from 'echarts';

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss'],
    standalone: false
})
export class PieChartComponent implements OnInit, DoCheck {
  @Input() public data: any[] = [];
  @Input() public chartOptions: any = {};
  public options: EChartsOption = {
    legend: {
      show: false,
      bottom: 5,
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)',
    },
    series: [
      {
        name: 'Radius Mode',
        type: 'pie',
        radius: [20, 140],
        startAngle: 0,
        center: ['50%', '50%'],
        roseType: 'radius',
        itemStyle: {
          borderRadius: 5,
        },
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        data: [],
      },
    ],
  };
  public lastHash!: string;

  constructor() {}

  ngOnInit(): void {
    (this.options.series as any)[0] = {
      ...(this.options.series as any)[0],
      data: [...this.data],
    };
    this.options = { ...this.options, ...this.chartOptions };
  }

  ngDoCheck() {
    const hash = SHA1(JSON.stringify(this.data)).toString();
    const getRandomColor = () => `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;

    const randomPalette = Array.from({ length: this.data.length }, () => getRandomColor());

    if (this.lastHash != hash) {
      this.lastHash = hash;
      this.options = {
        ...this.options,
        ...this.chartOptions,
        color: randomPalette,
        series: [{ ...(this.options?.series as any)[0], data: [...this.data] }],
      };
    }
  }
}
